import { Component } from 'react';

class AIActivityResources extends Component {

  componentDidMount() {
  }

  render() {
    return (
      <ul>
        {this.props.resources && this.props.resources.map((resource, index) => {
          return (
            <li key={index}>
              <a href={resource.link} target="_blank" rel="noopener noreferrer">
                <strong>{resource.title}</strong>
              </a>
            </li>
          )
        }
        )}
      </ul>
    );
  }
}

export default AIActivityResources;